<template>
    <div id="NormalUpload">
        <a-row>
            <a-col :span="6" class="normalTitle">
                <span>{{config.title}}</span><span v-if="config.valid" class="isValid">*</span>
            </a-col>
            <a-col v-if="!isCanEdit" :span="17" :offset="1" style="text-align: left">
                <span>{{data.value}}</span>
            </a-col>
            <a-col v-if="isCanEdit" :span="17" :offset="1" class="normalInput" style="text-align: left">
                <a-upload :file-list="fileList"
                          :remove="handleRemove"
                          :before-upload="beforeUpload"
                          :accept="acceptFile"
                          @change="handleUpload">
                    <a-button v-if="isCanEdit"> upload</a-button>
                </a-upload>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    export default {
        name: 'NormalUpload',
        props: ['data', 'isCanEdit'],
        data() {
            return {
                fileList: [],
                defaultFileList: [],
                uploading: false,
                fileSize: 0,
                fileSizeShow: 0,
                acceptFile: '.doc,.docx,.xls,.xlsx,.ppt,.pptx,image/*,.pdf,.tif,.pcx',
                config: {
                    title: '',
                    inputStyle: 'text',
                    placeholder: '',
                    valid: false,
                    errorMsg: '',
                    selectArray: [],
                    action: ''
                }
            }
        },
        destroyed() {
        },
        created() {
            this.config = this.data
            if (this.data.value) {
                this.fileList = [
                    {
                        uid: this.data.value,
                        name: this.data.value,
                        status: 'done'
                    }
                ]
            }
        },
        methods: {
            handleRemove(file) {
                const index = this.fileList.indexOf(file)
                const newFileList = this.fileList.slice()
                newFileList.splice(index, 1)
                this.fileList = newFileList

                if (file.status && file.status === 'removed') {
                    this.data.value = ''
                }
                this.fileSize = 0;
                const sendParam = {
                    item: this.data,
                    file: this.fileList,
                    size: this.fileSize
                }
                this.$emit('handleRemoveAction', sendParam)
            },

            beforeUpload(file) {
                this.fileSize = file.size
                this.fileList = []
                if (file) {
                    this.data.value = ''
                }
                this.fileList = [file]
                return false
            },
            handleUpload(event) {
                const sendParam = {
                    item: this.data,
                    file: this.fileList,
                    size: this.fileSize
                }
                this.$emit('uploadFile', sendParam)
            }
        }
    }
</script>

<style scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    #NormalUpload {
        margin-top: 20px;
        text-align: right;
    }

    .normalTitle {
        word-wrap: break-word;
        color: rgb(49, 112, 143);
        font-size: 14px;
        font-weight: 700;
    }

    .normalInput {
        font-size: 14px;
        font-weight: 400;
        color: #222;
    }

    .isValid {
        color: red;
    }

    .errorMsg {
        margin-top: 4px;
        text-align: left;
        color: red;
    }

</style>
